export default {
  development: {
    // 开发
    // SYSID: '003', // 系统id
    // HOST: 'https://test.wx.longnows.cn:38443/www',
    // COMMON: 'https://test.wx.longnows.cn:38443/common', // 个人信息、管理员等跳转地址
    // PLAT: 'https://test.wx.longnows.cn:38443/plat', // 统一登录平台
    // FILE: 'https://test.wx.longnows.cn:38443/zuul', // 文件上传
    // API: 'https://test.wx.longnows.cn:38443' // api接口服务器地址
    // PLAT: 'http://118.178.89.66:11888/plat', // 统一登录平台
    // API: 'http://118.178.89.66:11000', // api接口服务器地址
    // COMMON: 'http://192.168.0.129:8072/common' // 个人信息、管理员等跳转地址
    SYSID: '003', // 系统id
    HOST: 'https://www.5ibaoguan.cn/www',
    COMMON: 'https://www.5ibaoguan.cn/common', // 个人信息、管理员等跳转地址
    PLAT: 'https://login.longnows.cn', // 统一登录平台
    FILE: 'https://www.5ibaoguan.cn/zuul', // 文件上传
    API: 'https://www.5ibaoguan.cn' // api接口服务器地址
  },
  testing: {
    // 测试
    SYSID: '003', // 系统id
    HOST: 'https://test.wx.longnows.cn:38443/www',
    COMMON: 'https://test.wx.longnows.cn:38443/common', // 个人信息、管理员等跳转地址
    PLAT: 'https://test.wx.longnows.cn:38443/plat', // 统一登录平台
    FILE: 'https://test.wx.longnows.cn:38443/zuul', // 文件上传
    API: 'https://test.wx.longnows.cn:38443' // api接口服务器地址
  },
  production: {
    // 生产
    SYSID: '003', // 系统id
    HOST: 'https://www.5ibaoguan.cn/www',
    COMMON: 'https://www.5ibaoguan.cn/common', // 个人信息、管理员等跳转地址
    PLAT: 'https://login.longnows.cn', // 统一登录平台
    FILE: 'https://www.5ibaoguan.cn/zuul', // 文件上传
    API: 'https://www.5ibaoguan.cn' // api接口服务器地址
  }
}
